const PROPERTY_FAVORITES_KEY = 'propertyFavorites';
const PROJECT_FAVORITES_KEY = 'upcomingProjectFavorites';

const readFavoriteIds = (storageKey) => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))];
  } catch (error) {
    console.error(`Error reading ${storageKey}:`, error);
    return [];
  }
};

const writeFavoriteIds = (storageKey, ids) => {
  try {
    const normalized = [...new Set(ids.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))];
    localStorage.setItem(storageKey, JSON.stringify(normalized));
  } catch (error) {
    console.error(`Error saving ${storageKey}:`, error);
  }
};

export const getPropertyFavoriteIds = () => readFavoriteIds(PROPERTY_FAVORITES_KEY);

export const getProjectFavoriteIds = () => readFavoriteIds(PROJECT_FAVORITES_KEY);

export const getAllBuyerFavoriteIds = () => [
  ...new Set([...getPropertyFavoriteIds(), ...getProjectFavoriteIds()]),
];

export const syncPropertyFavoriteLocal = (propertyId, shouldFavorite) => {
  const id = Number(propertyId);
  if (!Number.isFinite(id) || id <= 0) return;

  const ids = new Set(getPropertyFavoriteIds());
  if (shouldFavorite) {
    ids.add(id);
  } else {
    ids.delete(id);
  }
  writeFavoriteIds(PROPERTY_FAVORITES_KEY, [...ids]);
};

export const syncProjectFavoriteLocal = (projectId, shouldFavorite) => {
  const id = Number(projectId);
  if (!Number.isFinite(id) || id <= 0) return;

  const ids = new Set(getProjectFavoriteIds());
  if (shouldFavorite) {
    ids.add(id);
  } else {
    ids.delete(id);
  }
  writeFavoriteIds(PROJECT_FAVORITES_KEY, [...ids]);
};

export const isPropertyFavoriteLocal = (propertyId) =>
  getPropertyFavoriteIds().includes(Number(propertyId));

export const isProjectFavoriteLocal = (projectId) =>
  getProjectFavoriteIds().includes(Number(projectId));
